import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// Event financials (Sales seq Part 2) — read-only analytics rollup served
// by GET /api/events/{id}/financials. 60s staleTime since the underlying
// MERAC snapshot runs hourly; 403 from a non-financial user is suppressed
// (the FinancialsTab's client-side gate is the single source of the
// locked-state message).
export function useEventFinancials(eventId: number, enabled = true) {
  return useQuery({
    queryKey: ['financials', eventId],
    queryFn: () => ApiClient.eventFinancials(eventId),
    enabled: enabled && Number.isFinite(eventId) && eventId > 0,
    staleTime: 60_000,
    retry: (count, err) => {
      if (err instanceof Error && err.message.startsWith('403')) return false
      return count < 2
    },
  })
}

// Event income (A+B+C) — GET /api/events/{id}/income. Booked + gate + on-the-day
// takings. Same gating/cadence as financials; 403 (non-financial) not retried.
export function useEventIncome(eventId: number) {
  return useQuery({
    queryKey: ['event-income', eventId],
    queryFn: () => ApiClient.eventIncome(eventId),
    enabled: Number.isFinite(eventId) && eventId > 0,
    staleTime: 60_000,
    retry: (count, err) => {
      if (err instanceof Error && err.message.startsWith('403')) return false
      return count < 2
    },
  })
}
